import currencyExchangeRatesApiService from '@/services/api/CurrencyExchangeRates'

const emptyFilters = {
  base: null,
  quote: null
}
const currencies = ['EUR', 'GBP', 'USD', 'HRK', 'SEK', 'THB']

class CurrencyExchangeRate {
  constructor() {
    this.api = currencyExchangeRatesApiService
    this.emptyFilters = emptyFilters
    this.currencies = currencies
  }

  getCurrencySymbol(currency) {
    switch (currency) {
      case 'EUR':
        return '€'
      case 'GBP':
        return '£'
      case 'USD':
        return '$'
      default:
        return currency
    }
  }
}

const currencyExchangeRate = new CurrencyExchangeRate()

export default currencyExchangeRate
